import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row, Button, Spinner, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { stateListAPI } from 'actions/StateMaster/stateMasterAction';
import { countryListAPI } from 'actions/CountryMaster/countryMasterAction';
import { clientDetailDataAction, clientDetailListAPI, generateClientDetailListPdfAPI } from 'actions/ClientDetailList/clientDetailListAction';
import TablePagination from 'components/common/TablePagination';
import loader from '../../assets/img/loader.svg'

export const ClientDetailListDetails = () => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [countryList, setCountryList] = useState([]);
	const [stateList, setStateList] = useState([]);
	const [pageNumber, setPageNumber] = useState(1);
	const [pageSize, setPageSize] = useState(5);
	const [clientDetailCount, setClientDetailCount] = useState(0);
	const [clientDetailCountList, setClientDetailList] = useState([]);
	let pageCount = Math.ceil(clientDetailCount / pageSize);
	const isPreviousDisabled = pageNumber === 1;
	const isNextDisabled = pageNumber === pageCount;
	let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
	const headers = {
		Authorization: `Bearer ${JSON.parse(token).value}`
	};

	const clientDetailListReducer = useSelector((state) => state.rootReducer.clientDetailListReducer)
	var clientDetailData = clientDetailListReducer.clientDetailData;

	useEffect(() => {
		getCountries();
	}, [])

	const GenerateClientDetailListPDF = async (page, size = pageSize, searchText) => {
			let requestData = {
				PageNumber: page ? page : pageNumber,
				pageSize: size,
				SearchText: searchText ? searchText : "",
				EncryptedAdvocateCode: localStorage.getItem('EncryptedAdvocateCode'),
				clientType: clientDetailData.clientType ? clientDetailData.clientType : "",
				stateCode: clientDetailData.stateCode ? clientDetailData.stateCode : "",
				IsPDFTrue: true
			}
			await dispatch(
				generateClientDetailListPdfAPI(
					requestData,
					(res) => {
						console.log(res);
					},
					(err) => {
						toast.error("No records found!", {
							theme: 'colored',
							autoClose: 10000
						});
						console.error("Error occurred while generating PDF:", err?.message || err);
					},
					headers
				)
			);
	}

	const fetchClientDetailList = async (newPageNumber, newPageSize) => {
			let requestData = {
				EncryptedAdvocateCode: localStorage.getItem("EncryptedAdvocateCode"),
				clientType: clientDetailData.clientType ? clientDetailData.clientType : "",
				stateCode: clientDetailData.stateCode ? clientDetailData.stateCode : "",
				PageNumber: newPageNumber ? newPageNumber : pageNumber,
				PageSize: newPageSize ? newPageSize : pageSize,
				IsPDFTrue: false
			}
			setIsLoading(true);
			await dispatch(
				clientDetailListAPI(
					requestData,
					res => {

						if (res.data.data.clientDetailList.length > 0) {
							setIsLoading(false);
							setClientDetailList(res.data.data.clientDetailList)
							setClientDetailCount(res.data.data.totalCount)
						} else {
							setIsLoading(false);
							setClientDetailList([])
							setTimeout(function () {
								$('#no-case-schedule-message').html('No records found!');
							}, 100)
						}
					},
					err => {
						setIsLoading(false);
						setClientDetailList([])
						setTimeout(function () {
							$('#no-case-schedule-message').html('No records found!');
						}, 100)
						console.log(err?.data.message);
					},
					headers
				)
			);
	}

	const getCountries = async (page, size = pageSize) => {
		const data = {
			pageNumber: page,
			pageSize: size,
			SearchText: '',
			isDropDown: true,
		};
		await dispatch(countryListAPI(
			data,
			(res) => {
				let countryData = [];
				if (res.data.data.countryList.length > 0)
					res.data.data.countryList.forEach(country => {
						countryData.push({
							key: country.countryName,
							value: country.countryCode
						});
					});
				setCountryList(countryData);
			},
			(err) => {
				toast.error(err?.data?.message || "Error fetching countries", {
					theme: 'colored',
					autoClose: 10000,
				});
				setCountryList([]);
			}
			, headers
		));
	};

	const getStates = async (selectCountryCode) => {
		const data = {
			countryCode: selectCountryCode,
			isDropDown: true,
			isList: false
		}
		await dispatch(stateListAPI(
			data,
			(res) => {

				let stateData = [];
				if (res && res.length > 0) {
					res.forEach(state => {
						stateData.push({
							key: state.stateName,
							value: state.stateCode
						});
					});
					setStateList(stateData);
				} else {
					setStateList([]);
				}
			},
			(err) => {
				setStateList([]);
			}
		));
	};

	const handleFieldChange = (e) => {
		dispatch(
			clientDetailDataAction({
				...clientDetailData,
				[e.target.name]: e.target.value,
			})
		);
		if (e.target.name == "countryCode") {
			setPageNumber(1)
			setPageSize(5)
			if (e.target.value == '')
				setStateList([]);
			else
				getStates(e.target.value);
		}
		 else if (e.target.name == "stateCode") {
			setPageNumber(1)
			setPageSize(5)
		}
	};

	const onPageClick = async ({ selected }) => {
		setPageNumber(selected + 1);
		fetchClientDetailList(selected + 1, pageSize)
	}
	const handlePageSize = async (e) => {
		setPageSize(e.target.value);
		setPageNumber(1);
		fetchClientDetailList(1, e.target.value)
	}

	const handlePreviousClick = async () => {
		setPageNumber(pageNumber - 1);
		fetchClientDetailList(pageNumber - 1, pageSize)
	}

	const handleNextClick = async () => {
		setPageNumber(pageNumber + 1);
		fetchClientDetailList(pageNumber + 1, pageSize)
	}

	return (
		<>
			{/* {isLoading ? (
				<Spinner
			  className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
					animation="border"
				/>
			) : null} */}
			      {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}
			<Form className="details-form cash-Collection-Report">
				<Row className='justify-content-left ms-2 casSchedule-button'>
					<Form.Label column className='col-auto'>
						Country
					</Form.Label>
					<Col className='col-auto client-list-filter'>
						<Form.Select id="txtCountry" name="countryCode"
							onChange={handleFieldChange}
							required>
							<option value=''>Select country</option>
							{countryList.map((option, index) => (
								<option key={index} value={option.value}>{option.key}</option>
							))}
						</Form.Select>
					</Col>
					<Form.Label column className='col-auto'>
						State
					</Form.Label>
					<Col className='col-auto client-list-filter'>
						<Form.Select id="txtState" name="stateCode"
							onChange={handleFieldChange}
							required>
							<option value=''>Select state</option>
							{stateList.map((option, index) => (
								<option key={index} value={option.value}>{option.key}</option>
							))}
						</Form.Select>
					</Col>
					<Form.Label column className='col-auto'>
						Client Type
					</Form.Label>
					<Col className='col-auto client-list-filter me-3'>
						<Form.Select
							name='clientType'
							onChange={(e) => handleFieldChange(e)}
							className="w-auto report-dropdown"
						>
							<option value="">Select type</option>
							<option value="INDIVIDUAL">INDIVIDUAL</option>
							<option value="ORGANIZATION">ORGANIZATION</option>
						</Form.Select>
					</Col>
					<Col className='col-auto next-date-button me3'>
						<Button className='me-2' onClick={() => fetchClientDetailList()}>Search Record</Button>
						{clientDetailCountList.length > 0 &&
						<Button onClick={() => GenerateClientDetailListPDF()}>Generate Report</Button>}
					</Col>
				</Row>
				<div className="case-schedule-table-container client-list-table">
					{clientDetailCountList.length > 0 ? (
						<Row className="no-padding">
							<Table striped bordered responsive className="table-md overflow-hidden case-schedule-table ">
								<thead className='custom-bg-200 case-schedule-thead'>
									<tr>
										<th>S. No</th>
										<th>State</th>
										<th>Client Name</th>
										<th>Contact Person</th>
										<th>Mobile No</th>
										<th>LandLine No</th>
										<th>Email Id</th>
										<th> Address</th>
										<th>Client Type</th>
									</tr>
								</thead>
								<tbody>
									{clientDetailCountList.map((item, index) => (
										<tr key={index} >
											<td>{index + 1}</td>
											<td>{item.stateName}</td>
											<td>{item.clientName}</td>
											<td>{item.contactPerson}</td>
											<td >{item.mobileNo}</td>
											<td >{item.landLineOffice}</td>
											<td >{item.emailId}</td>
											<td >
												{item.clientAddress1 && <span>{item.clientAddress1}</span>}
												{item.clientAddress2 && <span>, {item.clientAddress2}</span>}
												{item.clientAddress3 && <span>, {item.clientAddress3}</span>}
											</td>
											<td>{item.clientType}</td>
										</tr>
									))}
								</tbody>
							</Table>
						</Row>) : <Row className='justify-content-center mt-2'>
						<Col className='col-auto'>
							<h4 id="no-case-schedule-message"></h4>
						</Col>
					</Row>}
					{clientDetailCountList.length > 0 &&
						<Row className="PaymentReport-pagination" style={{ position: 'absolute', bottom: '40px', align: 'centre' }}>
							<TablePagination
								pageCount={pageCount}
								handlePageClick={onPageClick}
								pageSize={pageSize}
								handlePageSizeChange={handlePageSize}
								isDisablePrevious={isPreviousDisabled}
								isDisableNext={isNextDisabled}
								previousClick={handlePreviousClick}
								nextClick={handleNextClick}
								pageIndex={pageNumber - 1}
							/>
						</Row>}
				</div>
			</Form >
		</>
	)
}